
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay_pending",
      function () {
        return require("private-next-pages/pay_pending.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay_pending"])
      });
    }
  